import React from "react";
import styled, { css } from "styled-components";
import "./App.css";
import { resetAll } from "./features/gameSlice";
import background from "./assets/ok_bg.jpg";
import reset from "./assets/reset.png";
import fb from "./assets/fb.png";
import download from "./assets/download.png";
import { useAppDispatch } from "./app/hooks";

const Bg = styled.div`
  width: 100vw;
  height: 100vh;
  max-height: -webkit-fill-available;
  overflow: hidden;
  background-color: rgb(240, 230, 212);
  display: flex;
  align-items: center;
  flex-direction: column;
`;

const ImageContainer = styled.div<{ image: string }>`
  background: url(${(props) => props.image});
  background-size: contain;
  height: calc(100vh - 200px);
  margin-top: 20px;
  width: 88vw;
  background-repeat: no-repeat;
  background-position: center;
`;

const Icon = styled(ImageContainer)`
  height: 90px;
  width: 90px;
  margin: 10px;
`;

const Footer = styled.div`
  display: flex;
  width: 100%;
  position: absolute;
  justify-content: space-between;
  bottom: 0;
`;

function downloadBase64File(base64Data: string) {
  const downloadLink = document.createElement("a");
  downloadLink.href = base64Data;
  downloadLink.download = `Image_${Date.now()}`;
  downloadLink.click();
}

function Complete(props: { image: string }) {
  const dispatch = useAppDispatch();
  const { image } = props;
  const onPress = () => {
    downloadBase64File(image);
  };

  return (
    <Bg>
      <ImageContainer image={image} />

      <Footer>
        <Icon
          image={fb}
          onClick={() =>
            window.open("https://www.facebook.com/pinglin.tea.m/", "_blank")
          }
        />
        <Icon image={download} onClick={onPress} />
        <Icon
          image={reset}
          onClick={() => {
            dispatch(resetAll());
          }}
        />
      </Footer>
    </Bg>
  );
}

export default Complete;
